var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333 6.477h13.334A3.329 3.329 0 0 1 26 9.81v13.334a3.329 3.329 0 0 1-3.333 3.333H9.333A3.329 3.329 0 0 1 6 23.144V9.81a3.329 3.329 0 0 1 3.333-3.333Zm13.334 17.778a1.1 1.1 0 0 0 1.11-1.111v-7.778H20.29c.111.356.155.733.155 1.111 0 2.445-2 4.445-4.444 4.445s-4.444-2-4.444-4.445c0-.378.066-.755.155-1.111H8.222v7.778a1.1 1.1 0 0 0 1.111 1.11h13.334Zm-6.667-10c-1.222 0-2.222 1-2.222 2.222s1 2.222 2.222 2.222 2.222-1 2.222-2.222-1-2.222-2.222-2.222Zm2.933-1.111h4.845V9.81a1.1 1.1 0 0 0-1.111-1.11H9.333a1.1 1.1 0 0 0-1.11 1.11v3.334h4.844A4.4 4.4 0 0 1 16 12.033a4.4 4.4 0 0 1 2.933 1.11ZM21 9.477h2v2h-2v-2Z",
    fill: "#8CACAC"
  })));
};
export default SvgInstagram;